import { render, staticRenderFns } from "./batchEmail.vue?vue&type=template&id=96bf37de&scoped=true&"
import script from "./batchEmail.vue?vue&type=script&lang=js&"
export * from "./batchEmail.vue?vue&type=script&lang=js&"
import style0 from "./batchEmail.vue?vue&type=style&index=0&id=96bf37de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96bf37de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96bf37de')) {
      api.createRecord('96bf37de', component.options)
    } else {
      api.reload('96bf37de', component.options)
    }
    module.hot.accept("./batchEmail.vue?vue&type=template&id=96bf37de&scoped=true&", function () {
      api.rerender('96bf37de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmTool/email/components/batchEmail.vue"
export default component.exports